import React from "react";
import InputWithPen from "../../common/Inputs/InputWithPen.js";
import ImageFileInput from "../../common/Inputs/ImageFileInput.js";
import { TextArea } from "../../common/FormFields";
import ShortDescriptionEditor from "../../common/RichTextEditor/ShortDescriptionEditor";
import RenderHtml from "../../common/AppSpecificConpnents/PartsTable/RenderHtml.js";
import "./AddModule.css";
import { BASE } from "../../config.js";

const ModuleForm = ({
  // Form values
  selectedProject = "",
  procedureNumber = "",
  flowChartProcedureNumber = "",
  description = "",
  formShortDescription = "",
  previewUrl = "",

  // Handlers for opening popups
  onOpenProjectPopup,
  onOpenItemCodePopup,
  onOpenFlowchartPopup,

  // Handlers for clearing fields
  onClearProject,
  onClearItemCode,
  onClearFlowchart,

  // Image handlers
  onImageUpload,
  onDeleteImage,

  // Short description change handler
  onShortDescriptionChange,

  // State flags
  isUnlink = false,
  allowSave = true,
  moduleData = null,

  // Optional: for audit trail (all fields disabled)
  disabled = false,

  // Add Module live mode: hide Lexical toolbar; keep rich text visible
  shortDescriptionHideToolbarWhenReadOnly = false,

  // Image file input ID (optional, defaults to "fileInput")
  imageInputId = "fileInput",
  usingInAuditTrail = false,
}) => {
  const encodedSvg =
    "data:image/png;base64,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";
  const displayPreviewUrl = isUnlink ? encodedSvg : previewUrl;
  const isFieldDisabled = disabled || (moduleData ? true : false);
  const canInteract = !disabled && allowSave && !isUnlink;


  const uploadLable = (
    <>
      <label htmlFor={imageInputId} className="upload-prompt">
        <svg
          width="100"
          height="101"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.6338 101C7.66225 101 5.14706 99.9603 3.08824 97.8809C1.02941 95.8015 0 93.2611 0 90.2598V10.7402C0 7.73888 1.02941 5.19853 3.08824 3.11912C5.14706 1.03971 7.66225 0 10.6338 0H54.7515V8.91176H10.6338C10.1054 8.91176 9.67157 9.08307 9.33235 9.42568C8.99314 9.76829 8.82353 10.2064 8.82353 10.7402V90.2598C8.82353 90.7936 8.99314 91.2317 9.33235 91.5743C9.67157 91.9169 10.1054 92.0882 10.6338 92.0882H89.3662C89.8946 92.0882 90.3284 91.9169 90.6676 91.5743C91.0069 91.2317 91.1765 90.7936 91.1765 90.2598V45.701H100V90.2598C100 93.2611 98.9706 95.8015 96.9118 97.8809C94.8529 99.9603 92.3377 101 89.3662 101H10.6338ZM16.9691 78.3775H83.0309L62.5 50.7287L44.8529 73.8652L32.3529 57.8121L16.9691 78.3775ZM79.4118 32.6765V20.7941H67.6471V11.8824H79.4118V0H88.2353V11.8824H100V20.7941H88.2353V32.6765H79.4118Z"
            fill="#E3E3E3"
          />
        </svg>
        <span>
          <b>Upload a Image</b>
        </span>
      </label>
    </>
  );
  return (
    <>
      {/* Image Upload Section */}
      <div className="upload-section">
        <div
          className="upload-box"
          style={{
            cursor:
              usingInAuditTrail || !canInteract ? "not-allowed" : "pointer",
          }}
        >
          {displayPreviewUrl && displayPreviewUrl !== "null" ? (
            <>
              <div
                className="image-wrapper"
                style={{
                  cursor: usingInAuditTrail ? "not-allowed" : "pointer",
                }}
              >
                <img
                  src={
                    displayPreviewUrl.toLowerCase().includes("http") || isUnlink
                      ? displayPreviewUrl
                      : BASE + displayPreviewUrl
                  }
                  alt="Preview"
                  className="preview-image"
                />
              </div>
            </>
          ) : canInteract ? (
            <>{uploadLable}</>
          ) : null}
        </div>
        {!isUnlink && canInteract && (
          <div className="icon-actions">
            <label
              htmlFor={imageInputId}
              className="icon-button"
              title={
                !canInteract
                  ? "You do not have permission to upload images."
                  : "Upload"
              }
              style={{
                opacity: !canInteract ? 0.5 : 1,
                cursor: !canInteract ? "not-allowed" : "pointer",
                pointerEvents: !canInteract ? "none" : "auto",
              }}
            >
              <span className="upload-icon-circle">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 17 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 9.45021C1.13261 9.45021 1.25979 9.50289 1.35355 9.59666C1.44732 9.69042 1.5 9.8176 1.5 9.95021V12.4502C1.5 12.7154 1.60536 12.9698 1.79289 13.1573C1.98043 13.3449 2.23478 13.4502 2.5 13.4502H14.5C14.7652 13.4502 15.0196 13.3449 15.2071 13.1573C15.3946 12.9698 15.5 12.7154 15.5 12.4502V9.95021C15.5 9.8176 15.5527 9.69042 15.6464 9.59666C15.7402 9.50289 15.8674 9.45021 16 9.45021C16.1326 9.45021 16.2598 9.50289 16.3536 9.59666C16.4473 9.69042 16.5 9.8176 16.5 9.95021V12.4502C16.5 12.9806 16.2893 13.4894 15.9142 13.8644C15.5391 14.2395 15.0304 14.4502 14.5 14.4502H2.5C1.96957 14.4502 1.46086 14.2395 1.08579 13.8644C0.710714 13.4894 0.5 12.9806 0.5 12.4502V9.95021C0.5 9.8176 0.552678 9.69042 0.646447 9.59666C0.740215 9.50289 0.867392 9.45021 1 9.45021Z"
                    fill="#0D6EFD"
                  />
                  <path
                    d="M8.146 0.69621C8.19245 0.649647 8.24762 0.612704 8.30837 0.587498C8.36911 0.562291 8.43423 0.549316 8.5 0.549316C8.56577 0.549316 8.63089 0.562291 8.69163 0.587498C8.75238 0.612704 8.80755 0.649647 8.854 0.69621L11.854 3.69621C11.9479 3.7901 12.0006 3.91743 12.0006 4.05021C12.0006 4.18299 11.9479 4.31032 11.854 4.40421C11.7601 4.4981 11.6328 4.55084 11.5 4.55084C11.3672 4.55084 11.2399 4.4981 11.146 4.40421L9 2.25721V11.0502C9 11.1828 8.94732 11.31 8.85355 11.4038C8.75979 11.4975 8.63261 11.5502 8.5 11.5502C8.36739 11.5502 8.24021 11.4975 8.14645 11.4038C8.05268 11.31 8 11.1828 8 11.0502V2.25721L5.854 4.40421C5.80751 4.4507 5.75232 4.48757 5.69158 4.51273C5.63084 4.53789 5.56574 4.55084 5.5 4.55084C5.43426 4.55084 5.36916 4.53789 5.30842 4.51273C5.24768 4.48757 5.19249 4.4507 5.146 4.40421C5.09951 4.35772 5.06264 4.30253 5.03748 4.24179C5.01232 4.18105 4.99937 4.11595 4.99937 4.05021C4.99937 3.98447 5.01232 3.91937 5.03748 3.85863C5.06264 3.79789 5.09951 3.7427 5.146 3.69621L8.146 0.69621Z"
                    fill="#0D6EFD"
                  />
                </svg>
              </span>
            </label>
            {displayPreviewUrl && (
              <button
                type="button"
                className="icon-button"
                title={
                  !canInteract
                    ? "You do not have permission to delete images."
                    : "Delete"
                }
                onClick={onDeleteImage}
                disabled={!canInteract}
                style={{
                  opacity: !canInteract ? 0.5 : 1,
                  cursor: !canInteract ? "not-allowed" : "pointer",
                  pointerEvents: !canInteract ? "none" : "auto",
                }}
              >
                <span className="upload-icon-circle upload-icon-circle--with-margin">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 13 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.3125 5.75C4.42853 5.75 4.53981 5.79609 4.62186 5.87814C4.70391 5.96019 4.75 6.07147 4.75 6.1875V11.4375C4.75 11.5535 4.70391 11.6648 4.62186 11.7469C4.53981 11.8289 4.42853 11.875 4.3125 11.875C4.19647 11.875 4.08519 11.8289 4.00314 11.7469C3.92109 11.6648 3.875 11.5535 3.875 11.4375V6.1875C3.875 6.07147 3.92109 5.96019 4.00314 5.87814C4.08519 5.79609 4.19647 5.75 4.3125 5.75ZM6.5 5.75C6.61603 5.75 6.72731 5.79609 6.80936 5.87814C6.89141 5.96019 6.9375 6.07147 6.9375 6.1875V11.4375C6.9375 11.5535 6.89141 11.6648 6.80936 11.7469C6.72731 11.8289 6.61603 11.875 6.5 11.875C6.38397 11.875 6.27269 11.8289 6.19064 11.7469C6.10859 11.6648 6.0625 11.5535 6.0625 11.4375V6.1875C6.0625 6.07147 6.10859 5.96019 6.19064 5.87814C6.27269 5.79609 6.38397 5.75 6.5 5.75ZM9.125 6.1875C9.125 6.07147 9.07891 5.96019 8.99686 5.87814C8.91481 5.79609 8.80353 5.75 8.6875 5.75C8.57147 5.75 8.46019 5.79609 8.37814 5.87814C8.29609 5.96019 8.25 6.07147 8.25 6.1875V11.4375C8.25 11.5535 8.29609 11.6648 8.37814 11.7469C8.46019 11.8289 8.57147 11.875 8.6875 11.875C8.80353 11.875 8.91481 11.8289 8.99686 11.7469C9.07891 11.6648 9.125 11.5535 9.125 11.4375V6.1875Z"
                      fill="#DC3545"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12.1875 3.5625C12.1875 3.79456 12.0953  4.01712 11.9312 4.18122C11.7671 4.34531 11.5446 4.4375 11.3125  4.4375H10.875V12.3125C10.875 12.7766 10.6906 13.2217 10.3624 13.5499C10.0342 13.8781 9.58913 14.0625 9.125 14.0625H3.875C3.41087 14.0625 2.96575 13.8781 2.63756 13.5499C2.30937 13.2217 2.125 12.7766 2.125 12.3125V4.4375H1.6875C1.45544 4.4375 1.23288 4.34531 1.06878 4.18122C0.904687 4.01712 0.8125 3.79456 0.8125 3.5625V2.6875C0.8125 2.45544 0.904687 2.23288 1.06878 2.06878C1.23288 1.90469 1.45544 1.8125 1.6875 1.8125H4.75C4.75 1.58044 4.84219 1.35788 5.00628 1.19378C5.17038 1.02969 5.39294 0.9375 5.625 0.9375H7.375C7.60706 0.9375 7.82962 1.02969 7.99372 1.19378C8.15781 1.35788 8.25 1.58044 8.25 1.8125H11.3125C11.5446 1.8125 11.7671 1.90469 11.9312 2.06878C12.0953 2.23288 12.1875 2.45544 12.1875 2.6875V3.5625ZM3.10325 4.4375L3 4.48913V12.3125C3 12.5446 3.09219 12.7671 3.25628 12.9312C3.42038 13.0953 3.64294 13.1875 3.875 13.1875H9.125C9.35707 13.1875 9.57962 13.0953 9.74372 12.9312C9.90781 12.7671 10 12.5446 10 12.3125V4.48913L9.89675 4.4375H3.10325ZM1.6875 3.5625V2.6875H11.3125V3.5625H1.6875Z"
                      fill="#DC3545"
                    />
                  </svg>
                </span>
              </button>
            )}
          </div>
        )}
        <ImageFileInput
          id={imageInputId}
          accept="image/*"
          className="file-input"
          onChange={onImageUpload}
          hidden={true}
          disabled={isUnlink || !canInteract}
        />
      </div>

      {/* Form Fields */}
      <form className="module-form">
        <div className="form-row">
          {/* Project ID Dropdown */}
          <div className="form-group">
            <InputWithPen
              val={isUnlink ? "No module assigned" : selectedProject}
              label="Project ID"
              required={true}
              placeholder="Project ID"
              onClickOnPencil={() => {
                if (!isUnlink && !disabled && onOpenProjectPopup) {
                  onOpenProjectPopup();
                }
              }}
              onClear={() => {
                if (!disabled && onClearProject) {
                  onClearProject();
                }
              }}
              penBtnDisabled={isUnlink || isFieldDisabled || disabled}
              showClearIcon={
                isUnlink || isFieldDisabled || disabled ? false : true
              }
            />
          </div>
          <div className="form-group">
            <InputWithPen
              val={isUnlink ? "No module assigned" : procedureNumber}
              label="Item Code"
              required={true}
              placeholder="Enter Item Code"
              onClickOnPencil={() => {
                if (!isUnlink && !disabled && onOpenItemCodePopup) {
                  onOpenItemCodePopup();
                }
              }}
              onClear={() => {
                if (!disabled && onClearItemCode) {
                  onClearItemCode();
                }
              }}
              penBtnDisabled={isUnlink || isFieldDisabled || disabled}
              showClearIcon={
                isUnlink || isFieldDisabled || disabled ? false : true
              }
            />
          </div>
          <div className="form-group">
            <InputWithPen
              val={flowChartProcedureNumber}
              label="Flowchart Item Code"
              // placeholder={flowChartProcedureNumber ? "" : "Enter Flowchart Item Code"}
              placeholder=""
              onClickOnPencil={() => {
                if (!disabled && onOpenFlowchartPopup) {
                  onOpenFlowchartPopup();
                }
              }}
              onClear={() => {
                if (!disabled && onClearFlowchart) {
                  onClearFlowchart();
                }
              }}
              penBtnDisabled={usingInAuditTrail || disabled || isFieldDisabled}
              showClearIcon={
                usingInAuditTrail || disabled || isFieldDisabled
                  ? false
                  : !!flowChartProcedureNumber
              }
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group full-width">
            <label>Item Code Description (Read Only)</label>
            <RenderHtml
              descriptionBox={true}
              content={
                isUnlink ? "Document not assigned any Module" : description
              }
              disabled={disabled}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group full-width">
            <div
              className="form-field-margin-top"
              style={{ marginTop: "12px" }}
            >
              <label
                className="block font-semibold"
                style={{ marginBottom: "8px" }} 
              >
                Short Description
              </label>
              <div style={{ position: "relative" }}>
                <ShortDescriptionEditor
                  key={disabled ? "short-desc-readonly" : "short-desc-edit"}
                  value={formShortDescription}
                  onChange={(value) => {
                    if (onShortDescriptionChange) {
                      onShortDescriptionChange(value);
                    }
                  }}
                  placeholder="Enter short description"
                  minHeight="100px"
                  disabled={disabled}
                  compactLayout={true}
                  hideReadOnlyToolbar={shortDescriptionHideToolbarWhenReadOnly}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default ModuleForm;
